// Providers
import useBuildingProjectEnums from "./providers/BuildingProjectEnumsProvider";
import useCreateBuildingProject from "./providers/CreateBuildingProjectProvider";
import useCreateBuildingProjectWizard from "./providers/CreateBuildingProjectWizardProvider";
import useEditBuildingProjectWizard from "./providers/EditBuildingProjectWizardProvider";
import useModels from "./providers/ModelsProvider";

// Services
import createBuildingProject from "./services/CreateBuildingProjectService";
import updateBuildingProject, { updateProjectStage } from "./services/UpdateBuildingProjectService";
import * as includedPhasesConversion from "./services/IncludedPhasesConversionService";
import * as validateBuildingProject from "./services/ValidateBuildingProjectService";

// Providers
export {
  useBuildingProjectEnums,
  useCreateBuildingProject,
  useCreateBuildingProjectWizard,
  useEditBuildingProjectWizard,
  useModels,
};

// Services
const services = {
  createBuildingProject,
  updateBuildingProject,
  updateProjectStage,
  includedPhasesConversion,
  validateBuildingProject,
};

export { services };

// Types
export * from "./types/ApsModelType";
export * from "./types/BranchType";
export * from "./types/BuildingAddressType";
export * from "./types/BuildingProjectDetailsType";
export * from "./types/BuildingProjectType";
export * from "./types/CalculationTypeType";
export * from "./types/CreateBuildingProjectType";
export * from "./types/EmissionCalculationAssumptionsType";
export * from "./types/EmissionMetaDataType";
export * from "./types/HeatAreaType";
export * from "./types/LocalModelType";
export * from "./types/ModelType";
export * from "./types/NewBuildingProjectType";
export * from "./types/ProjectEnergyDataType";
export * from "./types/ReferencedAreasType";
export * from "./types/TransportTypesType";
export * from "./types/WizardProjectType";
export * from "./types/UpdateBuildingProjectTypes";
export * from "./types/UserInProjectType";
export * from "./types/SpeckleConfigurationType";

// Utils
export * from "./utils/classificationDefaults";
export * from "./utils/projectTemplate";

// Service helpers
export * from "./services/buildingAreaWriteInput";
